import asmModule from '../../../assembly/index.ts';

export default class asmManager {
  constructor() {
    this._instance = null;
    this._initialized = false;
    this._initializationPromise = null;
    this._exportedFunctions = [];
  }

  async initialize() {
    if (this._initialized) {
      return this;
    }

    if (this._initializationPromise) {
      await this._initializationPromise;
      return this;
    }

    try {
      this._initializationPromise = asmModule;
      this._instance = await this._initializationPromise;
      
      // Discover all exported functions
      this._discoverExports();
      
      // Create wrapper methods for all discovered functions
      this._createWrapperMethods();
      
      this._initialized = true;
      return this;
    } catch (error) {
      this._initializationPromise = null;
      throw new Error(`Failed to initialize WASM module: ${error.message}`);
    }
  }

  _discoverExports() {
    // Clear existing exports
    this._exportedFunctions = [];
    
    // Get all properties of the instance
    const properties = Object.getOwnPropertyNames(this._instance);
    
    // Filter for functions only
    for (const prop of properties) {
      if (typeof this._instance[prop] === 'function') {
        // Skip internal/special functions that start with underscore
        if (!prop.startsWith('_')) {
          this._exportedFunctions.push(prop);
        }
      }
    }

    // Log discovered functions (helpful for debugging)
    console.log('Discovered WASM exports:', this._exportedFunctions);
  }

  _createWrapperMethods() {
    for (const funcName of this._exportedFunctions) {
      // Skip if method already exists
      if (this[funcName]) {
        console.warn(`Skipping creation of wrapper for ${funcName} - method already exists`);
        continue;
      }

      // Create wrapper method
      this[funcName] = async (...args) => {
        await this._ensureInitialized();
        try {
          return this._instance[funcName](...args);
        } catch (error) {
          throw new Error(`Failed to execute ${funcName}: ${error.message}`);
        }
      };
    }
  }

  async _ensureInitialized() {
    if (!this._initialized) {
      await this.initialize();
    }
  }

  isInitialized() {
    return this._initialized;
  }

  // Get list of available functions
  getAvailableFunctions() {
    return [...this._exportedFunctions];
  }

  // Force rediscovery of exports (useful if WASM module is reloaded)
  async rediscoverExports() {
    if (!this._initialized) {
      await this.initialize();
      return;
    }

    this._discoverExports();
    this._createWrapperMethods();
  }
}

